(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    


  
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerWrapper = this;
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.headerHeightFrame = 0;
      this.lastHeaderHeight = null;
      this.lastStickyOffset = null;
      this.setHeaderHeight();

      this.setHeaderHeightHandler = this.scheduleHeaderHeight.bind(this);
      this.headerMedia = window.matchMedia('(max-width: 990px)');
      this.headerMedia.addEventListener('change', this.setHeaderHeightHandler);
      window.addEventListener('resize', this.setHeaderHeightHandler, { passive: true });
      window.addEventListener('load', this.setHeaderHeightHandler, { once: true });
      this.layoutRefreshHandler = () => {
        this.scheduleHeaderHeight();
        this.createObserver();
        this.onScroll();
      };
      window.addEventListener('brilinton:layout-refresh', this.layoutRefreshHandler);

      if (window.ResizeObserver) {
        this.headerHeightObserver = new ResizeObserver(this.setHeaderHeightHandler);
        this.headerHeightObserver.observe(this.headerWrapper || this.header);
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    scheduleHeaderHeight() {
      if (this.headerHeightFrame) return;
      this.headerHeightFrame = requestAnimationFrame(() => {
        this.headerHeightFrame = 0;
        this.setHeaderHeight();
      });
    }

    setHeaderHeight() {
      const measuredHeader = this.headerWrapper || this.header;
      if (!measuredHeader) return;

      const rect = measuredHeader.getBoundingClientRect();
      const headerHeight = Math.max(0, Math.round(measuredHeader.offsetHeight || rect.height || 0));
      const hasBorder = measuredHeader.classList.contains('header-wrapper--border-bottom');
      const stickyOffset = Math.max(0, Math.floor(headerHeight - (hasBorder ? 1 : 0)));
      const heightChanged = this.lastHeaderHeight === null || Math.abs(headerHeight - this.lastHeaderHeight) >= 2;
      const offsetChanged = this.lastStickyOffset === null || Math.abs(stickyOffset - this.lastStickyOffset) >= 2;

      if (!heightChanged && !offsetChanged) return;

      this.lastHeaderHeight = headerHeight;
      this.lastStickyOffset = stickyOffset;
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
      document.documentElement.style.setProperty('--site-sticky-offset', `${stickyOffset}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.setHeaderHeightHandler) {
        window.removeEventListener('resize', this.setHeaderHeightHandler);
        this.headerMedia?.removeEventListener('change', this.setHeaderHeightHandler);
      }
      if (this.layoutRefreshHandler) {
        window.removeEventListener('brilinton:layout-refresh', this.layoutRefreshHandler);
      }
      if (this.headerHeightFrame) cancelAnimationFrame(this.headerHeightFrame);
      if (this.headerHeightObserver) {
        this.headerHeightObserver.disconnect();
      }
      this.headerIntersectionObserver?.disconnect();
    }

    createObserver() {
      if (!this.header) return;
      this.headerIntersectionObserver?.disconnect();
      this.headerIntersectionObserver = new IntersectionObserver((entries, observer) => {
        if (entries[0]) this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      this.headerIntersectionObserver.observe(this.header);
    }


    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        document.body.classList.add('scrolled-past-header__body');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        document.body.classList.add('scrolled-past-header__body');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        document.body.classList.remove('scrolled-past-header__body');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }
    

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotspot_images"] && !Shopify.designMode) return;
  try {
    
    const selectHotspot = (e) => {
    const clickedHotspot = e.target.parentElement;
    const container = clickedHotspot.parentElement;
    const siblingHotspot = container.parentElement.parentElement.parentElement.nextElementSibling.querySelectorAll('.mobile-hotspot__container');
    // only include hotspots within same image to allow one open hotspot per image; change "container" to "document" to allow only one open hotspot for entire page:
    const hotspots = container.querySelectorAll(".lg-hotspot");
    hotspots.forEach((hotspot, hIndex) => {
      if (hotspot === clickedHotspot) {
        hotspot.classList.toggle("lg-hotspot--selected");
        if(siblingHotspot[hIndex]) {
          siblingHotspot[hIndex].classList.toggle("lg-hotspot--selected");
          let sibsBtn = siblingHotspot[hIndex].querySelector('.lg-hotspot__button')
          if(!sibsBtn.classList.contains("eventAddes")) {
            sibsBtn.classList.add('eventAddes')
            sibsBtn.addEventListener("click", () => {
              e.target.click();
            })
          }
        }
      } else {
        hotspot.classList.remove("lg-hotspot--selected");
        if(siblingHotspot[hIndex]) {
          siblingHotspot[hIndex].classList.remove("lg-hotspot--selected");
        }
      }
    });
  }

  (() => {
    const buttons = document.querySelectorAll(".lg-hotspot__button");
    buttons.forEach(button => {
      button.addEventListener("click", selectHotspot);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
